<template>
  <form
    v-on:submit.prevent
    v-if="this.options"
    :class="[
     'grid-filter string',
     options.classes,
     `field-${config.field}`
     ]"
    :style="options.styles">
    <el-form-item
      :label="fieldLabel"
      class="material-style"
    >
      <el-input
        v-model="model"
        @input="handleInput"
        :placeholder="placeholder"
        :prefix-icon="options.icon"
        :size="options.size"
        @paste.native="handlePaste"
        clearable
      />
    </el-form-item>
  </form>
</template>

<script>
import { mixFilters } from '../mixin'
import { handlePasteInput } from '@/utils/shared'

export default {
  name: 'NewFilterString',
  mixins: [mixFilters],
  props: {
    config: { type: Object, default: () => {} }
  },
  data () {
    return {
      model: '',
      options: this.ModelConfig(),
      currentTarget: {},
      handleInput: this.$_.debounce(this.handleChange, 1000)
    }
  },
  computed: {
    placeholder () {
      return this.checkEs6AndRun(this.options.placeholder)
    }
  },
  methods: {
    handlePaste (e) {
      handlePasteInput(e)
    },
    ModelConfig () {
      return {
        // eslint-disable-next-line
        valueTemplate: '${data.field}.contains("${data.value}")',
        value: '',
        // style
        placeholder: this.L10n('search'),
        icon: 'el-icon-search',
        classes: '',
        styles: { minWidth: '30rem' },
        size: ''
      }
    },
    handleChange (model = null) {
      this.model = model
      this.updateRendered()
      this.handle('change')
    },
    handleReset () {
      this.handleChange()
    },
    handleClear () {
      this.handleChange()
    },
    // FROM MIXINS
    parseConfig (Options) {
      this.handle('parseStart')
      // reset data
      this.options = null
      this.model = ''
      // update options
      this.options = this.$_.merge(this.ModelConfig(), this.config.options, Options || {})
      // update filters query
      this.updateRendered()
      this.handle('parseEnd')
      this.updateRendered()
      // Load data
      this.handle('init')
    },
    updateRendered () {
      this.result = this.options.value
      this.resultHuman = ''
      if (this.model) {
        this.result = this.createValue({
          field: this.config.field,
          value: this.model
        }, this)
        this.resultHuman = this.model
      }
    }
  }
}
</script>
